import { SxProps } from '@mui/material';
import { FC, useContext, useMemo } from 'react';

import { Root } from 'components/_CheckoutFooter/CartPreview/index.styled';
import PreviewCartProduct from 'components/PreviewCartProduct';
import { CartContext } from 'context/CartContext';
import { LocationContext } from 'context/LocationContext';

interface CartPreviewProps {
  sx?: SxProps;
}

const CartPreview:FC<CartPreviewProps> = ({ sx = {} }) => {
  const cart = useContext(CartContext);
  const products = useMemo(() => Object.values(cart?.products) || [], [cart?.products]);
  const { onboardingInfo } = useContext(LocationContext);

  return (
    <Root sx={sx} className="hidden-scroll">
      {products.map((product) => (
        <PreviewCartProduct
          product={product}
          key={product?.id}
          useType={onboardingInfo?.useType}
        />
      ))}
    </Root>
  );
};

export default CartPreview;
